import { useEffect, useRef, useState } from 'react'

let scriptLoaded = false

type VeppleProps = {
  id: string
  url?: string
  loader?: string
}

const Vepple = ({
  id,
  url = 'university-of-hull',
  loader = 'false'
}: VeppleProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 }
    )
    if (containerRef.current) {
      observer.observe(containerRef.current)
    }
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    if (isVisible && !scriptLoaded) {
      const script = document.createElement('script')
      script.src = 'https://rv-vepple-tour.web.app/vepple-tour.min.js'
      script.type = 'module'
      script.async = true
      document.body.appendChild(script)
      scriptLoaded = true
    }
  }, [isVisible])

  const VeppleTour = 'vepple-tour' as keyof JSX.IntrinsicElements

  return (
    <div ref={containerRef} className='h-full w-full'>
      {isVisible && (
        // @ts-expect-error: Custom element 'vepple-tour' is not recognised by TypeScript
        <VeppleTour loader={loader} id={id} url={url} />
      )}
    </div>
  )
}

export default Vepple
